var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",class:_vm.classNames,attrs:{"href":_vm.url ? _vm.url : null,"to":_vm.route ? _vm.route : null}},[_c('span',{staticClass:"BaseLink__Text"},[_vm._v(_vm._s(_vm.text))]),_c('BaseIcon',{staticClass:"BaseLink__Icon",attrs:{"icon":"arrow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }